"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Plan = function () {
  function Plan(parentContext, rootRequest) {
    this.parentContext = parentContext;
    this.rootRequest = rootRequest;
  }
  return Plan;
}();
exports.Plan = Plan;